import React from 'react'
import { LanguageContext } from '../contexts'
import { fillTemplateString } from '../utility'

export interface WorkshopNotFoundProps {
	workshopId: number
}

export const WorkshopNotFound = (props: WorkshopNotFoundProps) => {
	const { localizedText } = React.useContext(LanguageContext)

	const { workshopId } = props

	return (
		<div className='workshop-not-found'>
			<p className='is-size-5 select-prompt watermark-text is-pulled-left'>
				{localizedText.PleaseSelectAWorkshop}
			</p>
			<p className='is-size-5 watermark-text is-pulled-right'>
				{fillTemplateString(localizedText.WorkshopIdNotFoundTemplate, { workshopId })}
			</p>
		</div>
	)
}

export default WorkshopNotFound
